import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-output-variable',
  templateUrl: './output-variable.component.html',
  styleUrls: ['./output-variable.component.scss'],
  standalone: false,
})
export class OutputVariableComponent implements OnInit {

  @Input()
  text: string;
  @Input()
  handle: string;
  @Input()
  style: 'primary' | 'secondary' | 'third';
  @Input()
  selectedBadge: BehaviorSubject<string | undefined>;

  @HostBinding('className') componentClass: string;

  constructor() {
    this.componentClass = 'd-print-none';
  }

  ngOnInit(): void {
    if (!this.handle) {
      this.handle = this.text;
    }
  }

  setSelectedBadge(selectedBadge: string): void {
    if (this.selectedBadge.getValue() === selectedBadge) {
      this.selectedBadge.next(undefined);
    } else {
      this.selectedBadge.next(selectedBadge);
    }
  }
}
